// order of properties set in NOGA-1113 by Pernilla
// copied from Storefronts

export const properties = [
  // 1: brand
  'norce_brand',

  // 2: designer
  'norce_designer',

  // 3: dimensions
  'width_cm',
  'height_cm',
  'depth_cm',
  'length_cm',
  // (non-main dimensions)
  // try to maintain the relative orders
  // of width, height, etc as seen above
  'seat_height_cm',
  'seat_depth_cm',
  'diameter_cm',
  'max_width_cm',
  'max_height_cm',
  'max_depth_cm',
  'max_length_cm',
  'max_diameter_cm',
  'max_seat_height_cm',
  'max_seat_depth_cm',

  // (unsure about volume/areas)
  'content_volume_cl',
  'content_volume_liter',
  'content_volume_ml',

  // 4: remaining properties
  'accessories',
  'dimmable',
  'effect_watt',
  'ip_class',
  'language',
  'light_socket',
  'light_source_included',
  'norce_assembly_required',
  'norce_base_legs',
  'norce_color',
  'norce_features',
  'norce_light_source_quantity',
  'norce_material',
  'norce_seat',
  'norce_shape',
  'norce_surface_treatment',
  'norce_top',
  'norce_upholstery_category',
  'norce_variant',
  'removable_cover',
  'size',
  'upholstery_group',
  'upholstery_name',

  // 5: last of all, article number
  'id',
];

const CM = 'cm';

export const propertySuffixMap: { [key: string]: string } = {
  width_cm: CM,
  height_cm: CM,
  depth_cm: CM,
  seat_height_cm: CM,
  diameter_cm: CM,
  length_cm: CM,
  max_depth_cm: CM,
  max_diameter_cm: CM,
  max_height_cm: CM,
  max_length_cm: CM,
  max_seat_depth_cm: CM,
  max_seat_height_cm: CM,
  max_width_cm: CM,
  seat_depth_cm: CM,
};
